import { useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import EventEmitter, { SCROLL_DISABLE } from '../helpers/EventEmitter'
import { SCROLL_LAYOUT_ELEMENT_ID } from '../layout/LayoutContainer'
import { Content } from './Content'
import { coachMarkIgnoreRoutes, coachMarkRoutes } from './constants'
import './i18n'
import service from './store/Service'

let prevScreenUrl = undefined

export const CoachMark = ({ headRef, id, children }) => {
  const location = useLocation()

  const [data, setData] = useState([])
  const screenUrl = id || location.pathname

  useEffect(() => {
    if (
      prevScreenUrl &&
      screenUrl !== prevScreenUrl &&
      Object.values(coachMarkRoutes).includes(prevScreenUrl) &&
      !Object.values(coachMarkIgnoreRoutes).includes(prevScreenUrl)
    ) {
      service.updateCoachMarks({ screenUrl: prevScreenUrl }).then(() => {
        EventEmitter.dispatch(SCROLL_DISABLE, {
          id: SCROLL_LAYOUT_ELEMENT_ID,
          disable: false,
        })
      })
    }

    prevScreenUrl = screenUrl
  }, [screenUrl])

  if (!Object.values(coachMarkRoutes).includes(screenUrl)) {
    return children
  }

  return (
    <Content
      headRef={headRef}
      children={children}
      id={id}
      data={data}
      setData={setData}
    />
  )
}
